import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { Chip, IconButton, TablePagination } from "@material-ui/core"
import MaterialTable, { MTableToolbar } from "material-table"
import EditIcon from "@material-ui/icons/Edit"
import useStyles from "./styles"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import FirstPageIcon from "@material-ui/icons/FirstPage"
import LastPageIcon from "@material-ui/icons/LastPage"
const CommunicationEamilTable = ({
  emailsWithTags,
  toggleDialog,
  setSelectedEmail
}) => {
  const classes = useStyles()
  const { tags = [] } = useSelector(state => state.organization.currentOrg)

  const tableData = useMemo(() => {
    let tagsObj = {}
    tags.map(tag => {
      tagsObj = {
        ...tagsObj,
        [Number(tag.id)]: { id: Number(tag.id), name: tag.name }
      }
    })

    const handleClick = (email, tagData) => () => {
      setSelectedEmail({ ...email, tagData })
      toggleDialog()
    }

    const updatedEmailWithTags = emailsWithTags.map(email => {
      let tagIds
      let tagData = []

      if (email.tags !== null) {
        tagIds = email.tags.split(",")
        tagData = tagIds.map(tagId => ({
          id: Number(tagId),
          name: tagsObj[Number(tagId)] ? tagsObj[Number(tagId)].name : ""
        }))
      }

      const action = (
        <IconButton
          className={classes.emailActionButton}
          onClick={handleClick(email, tagData)}
        >
          <EditIcon />
        </IconButton>
      )

      if (email.tags === null) {
        return { ...email, action: action }
      }

      const tagChips = tagData.map(tag => {
        if (tag.name === "") {
          return null
        } else {
          return (
            <Chip
              key={tag.id}
              id={tag.id}
              label={tag.name}
              className={classes.tagChip}
            />
          )
        }
      })
      return { ...email, tags: tagChips, action: action }
    })

    return updatedEmailWithTags
  }, [emailsWithTags, tags, tags.length])

  const columns = [
    { title: "Email", field: "email", searchable: true },
    {
      title: "Tags",
      field: "tags",
      searchable: true,
      customFilterAndSearch: (value, rowData) => {
        let newArray = ""
        if (rowData.tags !== null) {
          newArray = rowData.tags
            .filter(x => x !== null)
            .map(x => x.props)
            .map(x => x.label.toLowerCase())
            .join(" ")
          if (newArray.includes(value.toLowerCase())) {
            return true
          }
        }
      }
    },
    {
      title: "",
      field: "action",
      width: null,
      cellStyle: {
        whiteSpace: "nowrap",
        width: 10 + "!important",
        maxWidth: 20 + "!important",
        minWidth: 20 + "!important",
        "& .MuiTableCell-body": {
          padding: "0px !important"
        }
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
        minWidth: 20
      }
      // search: true,
    }
  ]

  return (
    <div className={classes.tableContainer}>
      <MaterialTable
        columns={columns}
        data={tableData}
        title="Emails"
        style={{
          border: "none",
          boxShadow: "none",
          backgroundColor: "#fafafa"
        }}
        options={{
          showTitle: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, 30],
          maxBodyHeight: 550,
          // tableLayout: "fixed",
          searchFieldStyle: {
            width: "300px",
            maxWidth: "500px",
            marginRight: "80px"
          },
          searchFieldAlignment: "right",
          rowStyle: rowData => ({
            backgroundColor:
              rowData.tableData.id % 2 === 0 ? "#71338C0D" : "#fafafa"
          }),
          headerStyle: {
            borderBottom: "2px solid #71338C",
            color: "#71338C",
            fontWeight: "bold"
          }
        }}
        icons={{
          PreviousPage: () => <ChevronLeftIcon style={{ color: "black" }} />,
          NextPage: () => <ChevronRightIcon style={{ color: "black" }} />,
          FirstPage: () => <FirstPageIcon style={{ color: "black" }} />,
          LastPage: () => <LastPageIcon style={{ color: "black" }} />
        }}
        components={{
          Toolbar: props => (
            <div
              style={{
                textAlign: "right",
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <MTableToolbar {...props} />
            </div>
          )
        }}
      />
    </div>
  )
}

export default CommunicationEamilTable



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/CommunicationEmailTable/index.jsx